import IACASH_EXT_1 from "./IACASH_EXT_1";
export default {
  IACASH_EXT_1,
};
